import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ClaimJobDataPointsInputs from 'module/claims/views/claim/other/Claim.Job.DataPoints.Inputs';

const ClaimEditJobFormDataPoints = () => {
  const { form } = useModalForm<Api.Core.ClaimJob.Save.IRequest>();

  const updateValue = (value: string, id: number) => {
    const updatedDataPoints = form.data?.dataPoints?.map((item) =>
      id === item?.claimTypeDataPointId ? { ...item, value } : item
    );
    form.update({ dataPoints: updatedDataPoints });
  };

  return (
    <FormWrapper>
      <ClaimJobDataPointsInputs dataPoints={form?.data?.dataPoints} onUpdate={updateValue} />
    </FormWrapper>
  );
};

export default ClaimEditJobFormDataPoints;
